import type { IV1PageDataOfferCardResponse } from 'shared/repositories/dailyrent/entities/response/V1PageDataOfferCardResponse';

import { EDailyrentDataActionTypes } from './types';
import { getDailyrentOfferData } from '../../api/dailyrentOfferData';
import { actionGenerator } from '../../utils/redux/actionGenerator';

import type { IThunkActionCreator } from '../../store';
import type { IApplicationContext } from '../../types/applicationContext/applicationContext';

const setDailyrentDataFetched = actionGenerator<EDailyrentDataActionTypes.Fetched, IV1PageDataOfferCardResponse | null>(
  EDailyrentDataActionTypes.Fetched,
);

/**
 * Загрузка данных посуточной аренды (рейтинг, отзывы, цены на выбранные даты и тд)
 *
 * @param offerId - ID объявления
 * @returns Thunk action для загрузки данных
 */
export const fetchDailyrentData = (offerId: number): IThunkActionCreator<Promise<void>> => {
  return async (dispatch, getState, context: IApplicationContext) => {
    const dailyrentData = await getDailyrentOfferData(context, { offerId });

    dispatch(setDailyrentDataFetched(dailyrentData ?? null));
  };
};
